// Límite de intentos de entrada: 5 fallos seguidos bloquean 5 minutos. Lógica pura para poder probarla.
export const MAX_INTENTOS = 5;
export const BLOQUEO_MS = 5 * 60_000;
export type Intentos = { fallos: number; hasta: number }; // hasta: milisegundos (0 = sin bloqueo)

export const sinIntentos = (): Intentos => ({ fallos: 0, hasta: 0 });
export const estaBloqueado = (i: Intentos, ahora: number) => i.hasta > ahora;
export const minutosRestantes = (i: Intentos, ahora: number) => Math.max(1, Math.ceil((i.hasta - ahora) / 60_000));

/** Anota un fallo. Si el bloqueo anterior ya venció, se empieza de cero. */
export function conFallo(i: Intentos, ahora: number): Intentos {
  if (estaBloqueado(i, ahora)) return i;
  const base = i.hasta && i.hasta <= ahora ? sinIntentos() : i;
  const fallos = base.fallos + 1;
  return fallos >= MAX_INTENTOS ? { fallos, hasta: ahora + BLOQUEO_MS } : { fallos, hasta: 0 };
}
export const mensajeBloqueo = (i: Intentos, ahora: number) => `Demasiados intentos. Intenta de nuevo en ${minutosRestantes(i, ahora)} min`;
